import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-all duration-200',
  {
    variants: {
      variant: {
        default:
          'bg-primary/10 text-primary',
        secondary:
          'bg-muted text-muted-foreground',
        destructive:
          'bg-destructive/10 text-destructive',
        outline: 
          'border border-border bg-transparent text-foreground',
        success:
          'bg-success/10 text-success',
        warning:
          'bg-warning/20 text-warning-foreground',
        accent:
          'bg-accent/10 text-accent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
